import { api } from "./urlApi";

export const getAcolitos = async () => {
  const url = `${api}/acolitos/get.php`;

  const resp = await fetch(url);
  const acolitos = await resp.json();

  return acolitos.data;
};

export const getAcolitosActivos = async () => {
  const url = `${api}/acolitos/get.php?active=true`;

  const resp = await fetch(url);
  const acolitos = await resp.json();

  return acolitos;
};

export const getAcolitoById = async (id) => {
  const url = `${api}/acolitos/getById.php?id=${id}`;

  const resp = await fetch(url);
  const acolito = await resp.json();

  return acolito;
};

export const getDisponibilidadAcolito = async (id) => {
  const url = `${api}/acolitos/getDisponibilidad.php?id=${id}`;

  try {
    const resp = await fetch(url);
    const disponibilidad = await resp.json();
    return disponibilidad;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getPeriodosAusencia = async (activas) => {
  const url = `${api}/acolitos/getAusencias.php?activas=${activas}`;

  try {
    const resp = await fetch(url);
    const periodos = await resp.json();
    return periodos;
  } catch (error) {
    console.log(error);
    return false;
  }
};

//CREATE

export const addAcolito = async (acolito) => {
  const url = `${api}/acolitos/addAcolito.php`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(acolito),
    });

    return resp;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const addAusencia = async (ausencia) => {
  const url = `${api}/acolitos/addAusencias.php`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(ausencia),
    });

    return resp;
  } catch (error) {
    console.log(error);
    return false;
  }
};

//PUT

export const updateAcolito = async (acolito) => {
  const url = `${api}/acolitos/update.php`;

  try {
    const resp = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(acolito),
    });

    return resp;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const updateDisponibilidadAcolito = async (horarios, idAcolito) => {
  const url = `${api}/acolitos/updateDisponibilidad.php?id=${idAcolito}`;

  try {
    const resp = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(horarios),
    });

    return resp;
  } catch (error) {
    console.log(error);
    return false;
  }
};
